<template>
  <section class="dvs-card">
    <div class="dvs-section-head">
      <h1 class="dvs-section-title">Datos de Registro</h1>
    </div>

    <DVSDateField
      v-model="localForm.fecha"
      id="dvs-fecha"
      label="Fecha de Reporte"
      placeholder="DD/MM/AAAA"
      :error="errors.fecha"
      error-message="Captura la fecha en formato día/mes/año."
      @update:modelValue="notifyFieldChange('fecha')"
    />

    <DVSDropdown
      v-model="localForm.operador"
      label="Operador"
      placeholder="Nombre del operador"
      :options="operadores"
      :error="errors.operador"
      error-message="Selecciona un operador."
      @select="handleOperadorSelect"
    />

    <DVSDropdown
      v-model="localForm.maquina"
      label="Máquina"
      placeholder="Selecciona máquina"
      :options="maquinas"
      :error="errors.maquina"
      error-message="Selecciona una máquina."
      @select="handleMaquinaSelect"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";

import DVSDateField from "../components/DVSDateField.vue";
import DVSDropdown from "../components/DVSDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  operadores: {
    type: Array,
    default: () => [],
  },
  maquinas: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleOperadorSelect(option) {
  localForm.value.operadorLabel = option.label;
  notifyFieldChange("operador");
}

function handleMaquinaSelect(option) {
  localForm.value.maquinaLabel = option.label;
  notifyFieldChange("maquina");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
